import React from 'react';
import { BrowserRouter } from 'react-router-dom';

import { createTheme, ThemeProvider } from '@mui/material/styles';

import Routes from './routes.js';

const theme = createTheme({
  palette: {
    mode: 'light',
    primary: {
      main: '#d9be29',
    },
    secondary :{
      main: '#323232',
    }
  },
});


function App() {
  return (
    <BrowserRouter>
      <html style={styles.html}>
        <head>
          <meta
            name="viewport"
            content="minimum-scale=1, initial-scale=1, width=device-width"
          />
        </head>
        <link rel="stylesheet" href="https://fonts.googleapis.com/css?family=Roboto:300,400,500,700&display=swap" />
        <link rel="stylesheet" href="https://fonts.googleapis.com/icon?family=Material+Icons" />

        <ThemeProvider theme={theme}>
          <Routes />
        </ThemeProvider>
      </html>
    </BrowserRouter>
  );
}

let styles = {
  html: {
    backgroundColor: '#E5E6F0',
  }
};

export default App;
